<script lang="ts">
	let { type }: { type?: string | null } = $props();
</script>

{#if type && type !== 'none'}
	<div aria-hidden={true} class={type}></div>
{/if}

<style lang="scss">
	div {
		pointer-events: none;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 1;
	}

	.single {
		background: radial-gradient(
			closest-side,
			rgba(0, 0, 0, 0) calc(100% - 1px),
			var(--graphic-color, var(--theme-primary)) 100%
		);
		background-repeat: repeat-x;
		background-size: 100% 100%;
	}

	.vertical {
		background: radial-gradient(
			closest-side,
			rgba(0, 0, 0, 0) calc(100% - 1px),
			var(--graphic-color, var(--theme-primary)) 100%
		);
		background-repeat: repeat-x;
		background-size: 100% 100%;

		@include sm {
			background-size: calc(100% / 2) 100%;
		}

		@include md {
			background-size: calc(100% / 3) 100%;
		}
	}
</style>
